<template>
  <div v-show="!hideButtons">
    <!-- <v-divider class="mr-4"></v-divider> -->
    <v-btn
      v-if="!hideClearButton"
      class="mr-1 white black--text"
      small
      @click="reset()"
      :disabled="disabledSave"
    >
      {{ $t("toClean") }}
    </v-btn>
    <v-btn
      class="info"
      small
      @click="save()"
      :disabled="disabledSave || disabledFromParent"
    >
      <v-icon v-if="handleFilterButtonTxt" small left>mdi-download</v-icon>
      <v-icon v-else small left>mdi-filter</v-icon>
      {{ handleFilterButtonTxt ? $t("download") : $t("toFilter") }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "save-filters-button",

  props: {
    disabledFromParent: {
      type: Boolean
    }
  },

  computed: {
    exportDocStatus() {
      return this.$store.state.filters.groupExport.value
    },

    hideButtons() {
      // Essas views controlam os requests internamente e não precisam do botão saveFilters
      const paths = [
        "bonusAndPromotions/listPromotionOnline",
        "bonusAndPromotions/freespins",
      ];

      let hide = false;

      paths.forEach((path) => {
        if (this.$route.path.includes(path)) {
          hide = true;
        }
      });

      return hide;
    },

    hideClearButton() {
      const paths = [
        "/reports/reportUsers",
        "/reports/reportSportBets",
        "/reports/reportDeposits",
        "/reports/reportWithdrawals",
        "/reports/reportCasinoBets",
        "/administratorPlayers/tagsConfig",
        "/players/tagsConfig"
      ];

      let hide = false;

      paths.forEach((path) => {
        if (this.$route.path.includes(path)) {
          hide = true;
        }
      });

      return hide;      
    },

    handleFilterButtonTxt() {
      const names = [
        "AdministratorReportsUsers",
        "AdministratorReportsSportBets",
        "AdministratorReportsDeposits",
        "AdministratorReportsWithdrawals",
        "AdministratorReportsCasinoBets",
        "ColabReportsUsers",
        "ColabReportsSportBets",
        "ColabReportsDeposits",
        "ColabReportsWithdrawals",
        "ColabReportsCasinoBets",
        "TagsConfig",
        "CollaboratorTagsConfig",
      ];

      let routeName;

      names.forEach((name) => {
        if (this.$route.name.includes(name)) {
          return routeName = name;
        }
      });

      return this.$route.name === routeName && this.exportDocStatus != "";
    },

    disabledSave() {
      return this.$store.state.filters.disabledSave;
    },
  },

  methods: {
    /// Set Save in store vuex;
    save() {
      // Fields Required
      // Autocomplete Regionals
      if (this.enableAutocompleteRegionals) {
        if (!this.$refs.form.validate()) {
          return;
        }
      }
      this.$store.commit("setSave", true);
      this.$store.commit("DisabledSave", true);
    },

    /// Reset Filters to Default;
    reset() {
      // Components Reset
      this.$store.commit("setRegionalId", "");
      this.$store.commit("setLocalId", "");
      this.$store.commit("setAgentId", "");
      this.$store.commit("setPlayerId", "");
      this.$store.commit("setCollectorId", "");
      this.$store.commit("setRouteId", "");
      this.$store.commit("setSelectStatus", 0);
      if (this.$route.name === "ListCategories") {
        this.$store.commit("setSelectCasinoLobby", "");
      } else {
        this.$store.commit("setSelectCasinoLobby", 0);
      }
      this.$store.commit("setProviderId", "");
      this.$store.commit("setCasinoCategoryName", "");
      this.$store.commit("setSelectCasinoTheme", "");
      this.$store.commit("setSelectCasinoVerticalCategory", "");
      this.$store.commit("setGroupStatus", 1);
      this.$store.commit("setSelectResultBet", 3);
      this.$store.commit(
        "setSelectCasinoGroupBy",
        this.$route.name == "CasinoListBetOnline" ||
          this.$route.name === "CollaboratorCasinoListBetOnline"
          ? "game"
          : "jogo"
      );
      this.$store.commit("setSelectStatusBet", 1);
      this.$store.commit("setSelectEventStage", "");
      this.$store.commit("setSelectTypeBet", "deposit");
      this.$store.commit("setSelectTypeBetCasino", 0);
      this.$store.commit("setSelectStatusEvents", 1);
      this.$store.commit("setSinal", { option: "", valor: "" });
      this.$store.commit("setSinalDeposit", { option: "", valor: "" });
      this.$store.commit("setSinalAward", { option: "", valor: "" });
      this.$store.commit("setDepositValue", { option: "", value: "" });
      this.$store.commit("setSelectSport", {
        text: this.$t("sports"),
        value: "sports",
      });
      this.$store.commit("setBonusReportType", {
        text: this.$t("all"),
        value: "all",
      });
      this.$store.commit("setGamingType", {
        text: this.$t("all"),
        value: "all",
      });
      this.$store.commit("setPaymentProvider", {
        text: this.$t("all"),
        value: "all",
      });
      this.$store.commit("setEventNumber", "");
      this.$store.commit("setGroupOriginBetValue", "todos");
      this.$store.commit("setSelectFinancialCategoryAgent", 3);
      this.$store.commit("setGroupTypeLive", "");
      this.$store.commit("setGroupExport", "");
      this.$store.commit("setSelectTypeBankStatement", "");
      this.$store.commit("setSelectUserLogLevel", "");
      this.$store.commit("setSelectActionLog", "");
      this.$store.commit("setInputStringLog", "");
      this.$store.commit("setSelectStatusPlayers", "");
      this.$store.commit("setQuantityBet", 10);
      this.$store.commit("setHasInvoice", { value: "", text: "" });

      this.$store.commit("setSave", false);
      this.$store.commit("DisabledSave", false);

      this.$store.commit("setPaymentMonth", {
        value: (() => {
          let d = new Date(new Date().setMonth(new Date().getMonth() - 1));
          return new Date(d - d.getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 7);
        })(),
      });

      this.$store.commit("disablePaymentMonth");

      this.$nextTick(() => {
        this.$refs.form.inputs.forEach((input) => {
          if (!input.disabled) {
            input.reset();
          }
        });

        this.$store.commit("enablePaymentMonth");
      });
    },
  }
}

</script>